export default __webpack_public_path__ + "static/media/jbrowse.a69ef100.png";